import { memo, useCallback } from 'react';
import { ReactComponent as ErrorImg } from 'assets/images/403-img.svg';
import { ReactComponent as LogoImg } from 'assets/images/logo.svg';
import { useNavigateReplace } from 'hooks';
import { routes } from 'routes';
import { Button } from '@gravity-ui/uikit';

const ErrorPageRoute = () => {
	const navigate = useNavigateReplace();

	const handleClick = useCallback(
		(e: any) => {
			e.preventDefault();
			navigate(routes.root.getPath());
		},
		[navigate],
	);

	return (
		<div>
			<LogoImg />
			<ErrorImg />
			<div>Доступ запрещен</div>
			<div>У вас недостаточно прав для просмотра этого раздела</div>
			<Button onClick={handleClick}>Вернуться на главную</Button>
		</div>
	);
};

export default memo(ErrorPageRoute);
